import { gql } from '@edreamsodigeo/frontend-api-client';

const PRIME_SITE_PROPERTIES = gql`
  query PrimeSiteProperties {
    primeSiteProperties {
      isPrimeMarket
      activePrimeMarket {
        flights
      }
    }
  }
`;

export default PRIME_SITE_PROPERTIES;
